module.exports = __webpack_public_path__ + "static/media/SDFSA_6-240w.1708f110.webp";